import React from 'react';
import useSWR from 'swr';
import queryString from 'query-string';

import type { VFC } from 'react';

import Loading from '../../_components/Loading';

type Props = {
  cat: number,
};

const fetcher = (api) => {
  return fetch(api).then((res) => res.json());
};

const Recruit: VFC<Props> = ({ cat }) => {
  const { data } = useSWR(`../cgi-bin/recruit/api/recruit.php?cat=${cat}`, fetcher);

  if (!data) {
    return <Loading />;
  }

  const rows = data.recruit.list;

  if (!rows.length) return (
    <p className="recruitNo">現在募集を停止しております。</p>
  )

  return (
    <>
      {
        rows.map((row, index) => {
          return (
            <div className="mb100" key={index}>
              <table className="recruitTable">
                <tbody>
                  {
                    row.title
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">職種名</th>
                          <td className="recruitTableDetail">{row.title}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det1
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">事業内容</th>
                          <td className="recruitTableDetail">{row.det1}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det2
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">業務内容</th>
                          <td className="recruitTableDetail">{row.det2}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det3
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">試用期間</th>
                          <td className="recruitTableDetail">{row.det3}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det4
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">就業時間、休憩時間</th>
                          <td className="recruitTableDetail">{row.det4}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det5
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">時間外労働</th>
                          <td className="recruitTableDetail">{row.det5}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det6
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">募集人員</th>
                          <td className="recruitTableDetail">{row.det6}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det7
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">応募資格(学歴)</th>
                          <td className="recruitTableDetail">{row.det7}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det8
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">応募資格(特記事項)</th>
                          <td className="recruitTableDetail">{row.det8}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det9
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">給与(実績)関連・時給</th>
                          <td className="recruitTableDetail">{row.det9}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det10
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">昇給・賞与</th>
                          <td className="recruitTableDetail">{row.det10}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det11
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">福利厚生</th>
                          <td className="recruitTableDetail">{row.det11}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det12
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">休日・休暇</th>
                          <td className="recruitTableDetail">{row.det12}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det13
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">勤務</th>
                          <td className="recruitTableDetail">{row.det13}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det14
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">勤務地</th>
                          <td className="recruitTableDetail">{row.det14}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det15
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">選考方法</th>
                          <td className="recruitTableDetail">{row.det15}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det18
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">募集期間</th>
                          <td className="recruitTableDetail">{row.det18}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det16
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">お問い合わせ先</th>
                          <td className="recruitTableDetail">{row.det16}</td>
                        </tr>
                      ) : null
                  }
                  {
                    row.det17
                      ? (
                        <tr className="recruitTableRow">
                          <th className="recruitTableHead">その他</th>
                          <td className="recruitTableDetail">{row.det17}</td>
                        </tr>
                      ) : null
                  }
                </tbody>
              </table>
              <a className="recruitEntry" href="entry.html">応募はこちら</a>
            </div>
          );
        })
      }
    </>

  );
};

export default Recruit;